import * as Yup from 'yup';
import { BarcodeDataResponse, BatchInfo, ItemCategory, ItemGroup, uomDetails } from '../Common/inventory.helper';
import { postRequest } from '../../../services/httpService';


// ------------------- main tab styles -------------------

export function getTabSx(selectedTab: number, index: number) {
  return {
    marginTop: '10px',
    color: selectedTab === index ? '#E17E61' : '#CFD1D4',
    fontWeight: selectedTab === index ? 600 : 500,
    borderBottom: `2px solid ${selectedTab === index ? '#E17E61' : '#CFD1D4'}`,
    width: '33.33%',
    fontFamily: 'Montserrat',
  };
}


export const tabSx = {
  '& .MuiTabs-indicator': { display: 'none' },
};


//--------------sub tab styles--------------------
export const tabButtonStyles = {
  base: {
    backgroundColor: 'rgba(250, 250, 250, 1)',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    color: 'rgba(193, 193, 193, 1)',
    textTransform: 'capitalize',
    '&:hover': {
      color: '#E17E61 !important',
      fontWeight: 500,
      backgroundColor: '#FFFFFF',
      boxShadow: '1px 1px 4px 0px rgba(0, 0, 0, 0.2)',
      borderRadius: '10px',
      marginRight: '2px',
    },
  },
  selected: {
    backgroundColor: '#FFFFFF',
    boxShadow: '2px 2px 8px 2px rgba(225, 126, 97, 0.6)',
    fontWeight: 600,
    borderRadius: '10px',
    color: '#E17E61',
  },
};


export const subTabSx = {
  '& .MuiTabs-flexContainer': {
    padding: '10px', // Add desired padding
  },
  '& .MuiTabs-indicator': {
    display: 'none', // Remove the bottom indicator line
  },
  borderBottom: 'none', // Remove bottom border on the Tabs component
  justifyContent: 'space-between', // Ensure tabs are evenly spaced             
  borderRadius: '10px',
  '& .MuiTab-root.Mui-selected': {
    color: '#E17E61 !important', // Ensure your color takes precedence
    fontWeight: 'bold',
    backgroundColor: '#FFFFFF',
    boxShadow: '2px 2px 8px 0px rgba(0, 0, 0, 0.2)', // Highlight with box shadow
    borderRadius: '10px',
    marginRight:'4px'
  },
};


export const FilterIconSx={ width: '43px', height: '43px', cursor: 'pointer' };

export const AddIconSx={ width: '43px', height: '43px', cursor: 'pointer' };

export const selectedChipCloseSx={ width: '20px', height: '20px', cursor: 'pointer' };


export const filterSearchTextBoxSx = {
  width: '100%',        
  bgcolor: '#FFFFFF',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#E2E3E5',
    },
    '&:hover fieldset': {
      borderColor: '#E2E3E5',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#E2E3E5',
    },
    '& .MuiInputBase-input': { padding: '10px' }
  },
};


//--------------dummy data for stock------------------------------

// Sample list of 10 clinics for Autocomplete
export const ClinicsList = [
  { label: 'Clinic A', id: 1 },
  { label: 'Clinic B', id: 2 },
  { label: 'Clinic C', id: 3 },
  { label: 'Clinic D', id: 4 },
  { label: 'Clinic E', id: 5 },
  { label: 'Clinic F', id: 6 },
  { label: 'Clinic G', id: 7 },
  { label: 'Clinic H', id: 8 },
  { label: 'Clinic I', id: 9 },
  { label: 'Clinic J', id: 10 }
];

export const StoreList = [
  { label: 'Store A', id: 1 },
  { label: 'Store B', id: 2 },
  { label: 'Store C', id: 3 },
  { label: 'Store D', id: 4 },
  { label: 'Store E', id: 5 },
  { label: 'Store F', id: 6 },
  { label: 'Store G', id: 7 },
  { label: 'Store H', id: 8 },
  { label: 'Store I', id: 9 },
  { label: 'Store J', id: 10 }
];


export interface stockFilterValues {
    ItemGroupList: ItemGroup[];
    ItemCategoryList: ItemCategory[];
    stockStatus: string[];
    fromDate: string;
    toDate: string;
}

export interface indentStockFilterValues {
    ItemGroupList: ItemGroup[];
    ItemCategoryList: ItemCategory[];
    stockStatusArray: string[];
    fromDate: string;
    toDate: string;
}

export interface addStockFilterValues {
    ItemGroupList: ItemGroup[];
    ItemCategoryList: ItemCategory[];
}

export interface subTabs{
  label: string;
  value: allStockTabsdetails;
  count: number;
}


type allStockTabsdetails =  'All' | 'Stock' | 'GRN' | 'Received';

export interface tabsDetails{
  label: string;
  value: list_header_type_details;
}

type list_header_type_details =  'all_stock' | 'available_stock' | 'indent_required' | 'purchase_required';

//-------------------------------

export type TransferType = 'GRN' | 'Stock' | 'Received' | 'Quantity_Adjustment';

export type stockStatusType = 'Low_Stock' | 'No_Stock' | 'Near_Expiry' | 'Expired'


export interface TransferTypeDetails{
  label: string;
  value: TransferType;
}


export interface stockStatusTypeDetails{
  label: string;
  value: stockStatusType;
}

export interface stockDetails {
  id: number | string;  
  date?: string;
  itemCode: string;
  itemName: string;
  itemId: number;
  batchId: number;
  batchCode: string;
  expiryDate: string;
  itemGroup: string;
  itemCategory: string;
  isFree: boolean;
  transferType: TransferTypeDetails;
  openingStock: number;
  usedStock: number;
  stockAddition: number;
  closingStock: number;
  baseCost: number;
  totalCost: number;
  baseMrp: number;
  totalMrp: number;
  isScanBarCode: boolean;
  requestTo?: number | null;   // Store ID
  stockStatus?: stockStatusTypeDetails;
  base_uom_id:number;
  base_uom_code?:string;
  base_uom_name:string;
  is_low_stock: boolean;
  is_no_stock: boolean;
  is_near_expiry: boolean;
  is_expired?: boolean;
  clinic_name: string;
  clinic_id: number;
  store_name: string;
  store_id?: number;
  uom_object: uomDetails[];
  batch_object: BatchInfo[];
  barcode: BarcodeDataResponse | null;
  is_barcode_generated?: boolean;
  max_qty?: number;
  is_perishable: boolean;
}; 

interface tableItemDetails{
  label: string;
  value: string;
}

export interface mappedTableData{
  id: number | string; 
  itemId: number;
  batchId : number;
  batch_code: string;
  item_name: string;
  barcode : BarcodeDataResponse | null;
  details : stockDetails;
  date?: string;
  itemCode_itemName: tableItemDetails[];
  batchCode_expiryDate?: tableItemDetails[];
  itemGroup_itemCategory: tableItemDetails[];
  isFree?: boolean;
  transferType?: TransferTypeDetails;
  openingStock?: string;
  usedStock?: string;
  stockAddition?: string;
  closingStock?: string;
  costAmount: tableItemDetails[];
  mrpAmount: tableItemDetails[];
  isScanBarCode?: boolean;
  status?: stockStatusTypeDetails;
  is_low_stock?: stockStatusTypeDetails | null;
  is_no_stock?: stockStatusTypeDetails | null;
  is_near_expiry?: stockStatusTypeDetails | null;
  is_expired?: stockStatusTypeDetails | null;
  is_hold?: boolean;
  clinic_name?: string;
  store_name?: string;
  clinic_id?: number;
  store_id?: number;
  is_barcode_generated?: boolean;
  is_perishable: boolean;
}


export interface mappedIndentRequiredTableData{
  id: number | string;
  details : stockDetails;
  date: string;
  itemCode_itemName: tableItemDetails[];
  itemGroup_itemCategory: tableItemDetails[];
  requiredStock: string;
  availableStock: string;
  requestTo?: number | null;   // Store ID
  costAmount: tableItemDetails[];
  status?: stockStatusTypeDetails;
  batchCode_expiryDate?: tableItemDetails[];
  is_low_stock: stockStatusTypeDetails | null;
  is_no_stock: stockStatusTypeDetails | null;
  is_near_expiry: stockStatusTypeDetails | null;
  is_expired: stockStatusTypeDetails | null;
  clinic_name: string;
  store_name: string;
  clinic_id: number;
  store_id?: number;
}



//-------------------------------

export interface mappedAddStockTableData{
  unique_row_id: string; // unique row id
  item_id: number;
  item_name: string;
  item_code: string;
  action: React.ReactNode;
  batch_code: string;
  expiry_date: string;
  quantity: number | null;
  uom_id: number | null;
  uom: string;
  base_cost: number | null;
  total_cost: number;
  base_mrp: number | null;
  total_mrp: number;
  cgst_percent: number | null;
  cgst_amount: number;
  sgst_percent: number | null;
  sgst_amount: number;
  net_amount: number;
  uom_list: uomDetails[];
  min_expiry_in_days: number | null;
  conversion_factor: number;  // expected initial value: 1
  is_perishable: boolean;
}


export interface addStockInitialValues{
  tableData: mappedAddStockTableData[];
  clinic_id: number | null;
  store_id: number | null;
}

export const addStockInitialValue : addStockInitialValues= { 
  clinic_id: null,
  store_id: null,
  tableData: []
};

export const createAddStockValidationSchema = (tStock: (key: string) => string) => {
  return Yup.object().shape({
    clinic_id: Yup.number()
      .required(tStock('Validation_Clinic_Required')),
    store_id: Yup.number()
      .required(tStock('Validation_Store_Required')),
    tableData: Yup.array().of(
      Yup.object().shape({
        // batch_code: Yup.string().required(tStock('Validation_BatchCode_Required')),
        // expiry_date: Yup.string().required(tStock('Validation_ExpiryDate_Required')),
        batch_code: Yup.string().when('is_perishable', {
          is: true,
          then: (schema) => schema.required(tStock('Validation_BatchCode_Required')),
          otherwise: (schema) => schema.notRequired(),
        }),
        expiry_date: Yup.string().when('is_perishable', {
          is: true,
          then: (schema) => schema.required(tStock('Validation_ExpiryDate_Required')),
          otherwise: (schema) => schema.notRequired(),
        }),
        quantity: Yup.number()
          .required(tStock('Validation_Quantity_Required'))
          .min(1, tStock('Validation_Quantity_Min')),
        base_cost: Yup.number()
          .required(tStock('Validation_BaseCost_Required'))
          .min(0, tStock('Validation_BaseCost_Min'))
          .test('max-decimals', tStock('Validation_BaseCost_Decimals'), (value) => {
            if (value == null) return true; // Allow null values
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          })
          .test('is-greater-or-equal', tStock('Error_BaseCost_MRP'), function (value) {
            return value <= this.parent.base_mrp;
          }),
        base_mrp: Yup.number()
          .required(tStock('Validation_BaseMRP_Required'))
          .test('is-greater-or-equal', tStock('Error_BaseMRP_Cost'), function (value) {
            return value >= this.parent.base_cost;
          })
          .min(0, tStock('Validation_BaseMRP_Min'))
          .test('max-decimals', tStock('Validation_BaseMRP_Decimals'), (value) => {
            if (value == null) return true; // Allow null values
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          }),
        cgst_percent: Yup.number()
          .required(tStock('Validation_CGST_Required'))
          .min(0, tStock('Validation_CGST_Min'))
          .max(100, tStock('Validation_CGST_Max'))
          .test('max-decimals', tStock('Validation_CGST_Decimals'), (value) => {
            if (value == null) return true; // Allow null values
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          })
          .oneOf([Yup.ref('sgst_percent')], tStock('Error_CGST_SGST_Match')),
        sgst_percent: Yup.number()
          .required(tStock('Validation_SGST_Required'))
          .min(0, tStock('Validation_SGST_Min'))
          .max(100, tStock('Validation_SGST_Max'))
          .test('max-decimals', tStock('Validation_SGST_Decimals'), (value) => {
            if (value == null) return true; // Allow null values
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          })
          .oneOf([Yup.ref('cgst_percent')], tStock('Error_SGST_CGST_Match')),
        uom_id: Yup.number()
          .required(tStock('Validation_UOM_Required'))
          .min(1, tStock('Validation_UOM_Valid')),
      })
    ),
  });
};


export const calculateTaxAmount = (baseCost: number, taxPercent: number): number => {
  return parseFloat(((baseCost * (taxPercent || 0)) / 100 ).toFixed(2));
};

export const calculateTotalCostOrMRP = (baseValue: number, quantity: number): number => {
  return parseFloat(((baseValue || 0) * (quantity || 0)).toFixed(2));
};


export const calculateRowTotals = (row: mappedAddStockTableData) => {
  const quantity = row.quantity && row.quantity > 0 ? row.quantity : 0;
  const baseCost = row.base_cost || 0;
  const baseMRP = row.base_mrp || 0;
  const cgstPercent = row.cgst_percent || 0;
  const sgstPercent = row.sgst_percent || 0;

  const total_cost = calculateTotalCostOrMRP(baseCost, quantity);
  const total_mrp = calculateTotalCostOrMRP(baseMRP, quantity);

  const totalBaseCost = total_cost || 0;

  // Total tax amounts
  const cgst_amount = calculateTaxAmount(totalBaseCost, cgstPercent);
  const sgst_amount = calculateTaxAmount(totalBaseCost, sgstPercent);

  const net_amount = parseFloat((totalBaseCost + cgst_amount + sgst_amount).toFixed(2)); // Ensure 2 decimal places

  return { total_cost: parseFloat(total_cost.toFixed(2)), total_mrp: parseFloat(total_mrp.toFixed(2)), cgst_amount, sgst_amount, net_amount };
};


export interface OpeningBalanceDetail {
  item_id: number;
  batch_number: string | null;  // batch code 
  expiry_date: string | null;
  qty: number;
  uom_id: number;
  conversion_factor: number;  // default 1
  base_cost_price: string;
  base_mrp: string;
  total_cost_price: string;
  total_mrp: string;
  cgst_perc: string;
  sgst_perc: string;
  net_amount: string;
  cgst_amount: string;
  sgst_amount: string;
}

export interface OpeningBalance {
  clinic_id: number | null;
  store_id: number | null;
  is_freeze: boolean;
  opening_balance_details: OpeningBalanceDetail[];
}


export function createOpeningBalance(data: OpeningBalance): Promise<OpeningBalance> {
  const url = 'opening-balance/';  
  return postRequest(url, data, { responseType: 'json' });
}



export const mapToOpeningBalance = (data: addStockInitialValues): OpeningBalance => {
  return {
    clinic_id: data.clinic_id,
    store_id: data.store_id,
    is_freeze: false,
    opening_balance_details: data.tableData.map((item) => ({
      item_id: item.item_id,    
      batch_number: item.is_perishable ? item.batch_code : null,
      expiry_date: item.is_perishable ? item.expiry_date : null,
      qty: item.quantity || 0,
      uom_id: item.uom_id || 0,
      conversion_factor: typeof item.conversion_factor === 'number' && item.conversion_factor > 0 ? item.conversion_factor : 1, 
      base_cost_price: item.base_cost?.toString() || '0',
      base_mrp: item.base_mrp?.toString() || '0',
      total_cost_price: item.total_cost.toString(),
      total_mrp: item.total_mrp.toString(),
      cgst_perc: item.cgst_percent?.toString() || '0',
      sgst_perc: item.sgst_percent?.toString() || '0',
      net_amount: item.net_amount.toString(),
      cgst_amount: item.cgst_amount.toString(),
      sgst_amount: item.sgst_amount.toString(),
    })),
    
  };
};




export function generateReportHeaders(
  dataArray: mappedTableData[],
  labelMap: Record<string, string> = {}
): string[][] {
  if (!dataArray || dataArray.length === 0) return [[]];

  // Use keys from the first object
  const keys = Object.keys(dataArray[0].details);

  // Map keys to formatted labels
  const headers = keys.map((key) => {
    // Use custom label if exists
    if (labelMap[key]) return labelMap[key];

    // Otherwise format: "patient_name" → "Patient Name", "totalCost" → "Total Cost"
    return key
      .replace(/_/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();
  });

  return [headers]; // Return as 2D array
}


// ============================================================================
// SKELETON COLUMN WIDTHS FOR STOCK TABLES
// ============================================================================

/**
 * Column widths for AllAndAvailStockTable skeleton
 * Columns: barcode, date, itemCode_itemName, clinic_store, batchCode_expiryDate, 
 *          itemGroup_itemCategory, isFree, transferType, usedStock, stockAddition, closingStock, costAmount, mrpAmount
 */
export const ALL_STOCK_SKELETON_WIDTHS = [40, 100, 160, 140, 160, 160, 60, 100, 80, 80, 80, 120, 120];

/**
 * Column widths for AvailableStockDetails skeleton (no transferType column)
 * Columns: barcode, date, itemCode_itemName, clinic_store, batchCode_expiryDate,
 *          itemGroup_itemCategory, isFree, usedStock, stockAddition, closingStock, costAmount, mrpAmount
 */
export const AVAILABLE_STOCK_SKELETON_WIDTHS = [40, 100, 160, 140, 160, 160, 60, 80, 80, 80, 120, 120];

/**
 * Column widths for IntendRequiredDetails skeleton
 * Columns: checkbox, date, itemCode_itemName, clinic_store, itemGroup_itemCategory, 
 *          availableStock, requiredStock, requestTo, costAmount, status
 */
export const INDENT_REQUIRED_SKELETON_WIDTHS = [40, 100, 160, 140, 160, 100, 100, 160, 120, 100];

/**
 * Column widths for PurchaseRequiredDetails skeleton
 * Columns: checkbox, date, itemCode_itemName, clinic_store, itemGroup_itemCategory, 
 *          availableStock, requiredStock, costAmount, status
 */
export const PURCHASE_REQUIRED_SKELETON_WIDTHS = [40, 100, 160, 140, 160, 100, 100, 120, 100];